// extracted by mini-css-extract-plugin
export var button = "_h6-2";
export var card = "_h6-0";
export var closeButtonContainer = "_h6-3";
export var iconContainer = "_h6-1";